import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import posthog from 'posthog-js';

import { Paging } from 'e4shared';

import { setHomeWhatsHappening } from 'actions/dashboard';
import { hasModule } from 'helpers/profile';

import WhatsHappeningModal from 'views/home/components/whatsHappening/components/whatsHappeningModal';
import NextReview from 'views/home/components/whatsHappening/components/nextReview';
import StaffReviews from 'views/home/components/whatsHappening/components/staffReviews';
import CoachReviews from 'views/home/components/whatsHappening/components/coachReviews';
import ObjectivesAI from 'views/home/components/whatsHappening/components/objectivesAI';
import Objectives from 'views/home/components/whatsHappening/components/objectives';
import StaffObjectives from 'views/home/components/whatsHappening/components/staffObjectives';
import Pathway from 'views/home/components/whatsHappening/components/pathway';
import Learning from 'views/home/components/whatsHappening/components/learning';
import CaughtUp from 'views/home/components/whatsHappening/components/caughtUp';
import { addDays } from 'helpers/dates';

export const Focus = ({ profile, data, history, text, loading, tabsLoading }) => {
    const dispatch = useDispatch();
    const loaded = React.useRef(null);
    const [tiles, setTiles] = React.useState([]);
    const [showDone, setShowDone] = React.useState(true);
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        window.visualViewport?.addEventListener('resize', setToFit);

        return () => {
            window.visualViewport?.removeEventListener('resize', setToFit);
            setShow('');
        };
    }, []);

    const setShow = show => dispatch(setHomeWhatsHappening({ show, data }));

    React.useEffect(() => {
        let temp = [];
        const earliest = (d, prop = 'due') => d.sort((a, b) => (a[prop] > b[prop] ? 1 : -1))[0][prop];

        // data.unreviewed?.length &&
        //     temp.push({
        //         sort: `${earliest(data.unreviewed)}`,
        //         control: <Unreviewed focus data={data.unreviewed} setShow={() => setShow('unreviewed')} />,
        //     });

        hasModule(user, 'pathways') &&
            data.pathways?.length &&
            data.pathways.map(path =>
                temp.push({
                    sort: `${path.date_Due}-3:PATHWAY`,
                    control: <Pathway focus data={path} setShow={() => setShow('pathway')} />,
                })
            );

        !user.zero &&
            data.nextReview &&
            temp.push({
                sort: `${data.nextReview.scheduled}-2:REVIEW`,
                control: <NextReview focus data={data.nextReview} />,
            });

        data.staffReviews?.length &&
            temp.push({
                sort: `${earliest(data.staffReviews, 'scheduled')}-1:STAFF-2:REVIEW`,
                control: <StaffReviews focus data={data.staffReviews} setShow={() => setShow('staff-reviews')} />,
            });

        data.coachReviews?.length &&
            temp.push({
                sort: `${earliest(data.coachReviews, 'scheduled')}-1:COACH-2:REVIEW`,
                control: <CoachReviews focus data={data.coachReviews} setShow={() => setShow('coach-reviews')} />,
            });

        hasModule(user, 'objectives') &&
            data.objectivesAI?.length &&
            temp.push({
                sort: `${earliest(data.objectivesAI, 'due')}-5:OBJ`,
                control: <ObjectivesAI focus data={data.objectivesAI} setShow={() => setShow('objectivesAI')} />,
            });

        hasModule(user, 'objectives') &&
            data.objectives?.length &&
            temp.push({
                sort: `${earliest(data.objectives, 'due')}-5:OBJ`,
                control: <Objectives focus data={data.objectives} setShow={() => setShow('objectives')} />,
            });

        hasModule(user, 'objectives') &&
            data.staffObjectives?.length &&
            temp.push({
                sort: `${addDays(earliest(data.staffObjectives, 'date_Completed'), 7)}-1:STAFF-5:OBJ`,
                control: <StaffObjectives focus data={data.staffObjectives} setShow={() => setShow('staff-objectives')} />,
            });

        data.learning?.length &&
            temp.push({
                sort: `xxx-${earliest(data.learning, 'started_At')}-4:LEARNING`, // confirm ordering
                control: <Learning focus data={data.learning} profile={profile} />,
            });

        profile.isManager &&
            data.coachReviews?.length === 0 &&
            data.staffReviews?.length === 0 &&
            temp.length > 0 &&
            temp.push({
                sort: `999-1:STAFF-2:REVIEW`,
                control: <CaughtUp focus setShow={() => setShow('caughtup')} />,
            });

        setTiles(temp.sort((a, b) => (a.sort > b.sort ? 1 : -1)));
    }, [data]);

    const resetAll = () => {
        [...document.getElementsByClassName('tile')].map((t, i) => {
            t.style.paddingRight = '10px';
            t.style.paddingLeft = '0px';
        });
    };

    const setToFit = () => {
        resetAll();
        stretchLast(0);
    };

    React.useEffect(() => {
        if (loaded.current) {
            setToFit();
        }
    }, [loaded.current, tabsLoading]);

    if (loading || !data) return null;

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5,
            slidesToSlide: 1,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1,
        },
    };

    const stretchLast = current => {
        let show = 3;
        const width = document.body.clientWidth;
        if (width <= 1024) show = 2;
        if (width <= 464) show = 1;
        if (width >= 4000) show = 5;
        [...document.getElementsByClassName('tile')].map((t, i) => {
            if (i === current + show - 1) {
                t.style.paddingRight = '0';
            }
            if (i === current + show) {
                t.style.paddingLeft = '10px';
            }
        });
    };

    const ButtonGroup = ({ goToSlide, carouselState }) => {
        if (!carouselState) return null;

        const { currentSlide } = carouselState;

        const pages =
            carouselState.slidesToShow === 1
                ? tiles.length
                : carouselState.slidesToShow === 2
                ? tiles.length - 1
                : tiles.length - 2;

        return (
            <div className="flex flex-center">
                <h3 className="flex-grow">{text.focus.title}</h3>
                {pages > 1 && (
                    <div className="carousel-button-group items-center w-full">
                        <Paging
                            recordCount={pages > 0 ? pages : 0}
                            page={currentSlide + 1}
                            pageSize="1"
                            goToPage={x => {
                                goToSlide(x - 1);
                                posthog.capture('todays-focus-paged');
                            }}
                            bullets
                        />
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            {tiles.length === 0 ? (
                <div className="">
                    <h3 className="flex-grow pb10">{text.focus.title}</h3>
                    {showDone ? (
                        <div className="focus-caught-up p10 flex flex-center">
                            <i className="fa fa-check-circle mr10" />
                            <span className="flex-grow">{text.focus.allCaughtUp}</span>
                            <button className="btn btn-link ml10" onClick={() => setShowDone(false)}>
                                <i className="fa fa-times" />
                            </button>
                        </div>
                    ) : (
                        <div className="focus-explore">{text.explore}</div>
                    )}
                </div>
            ) : (
                <div className="focus-tiles" ref={loaded}>
                    <div className="flex flex-col-reverse">
                        <Carousel
                            renderButtonGroupOutside={true}
                            customButtonGroup={<ButtonGroup />}
                            afterChange={(p, c) => stretchLast(c.currentSlide)}
                            beforeChange={resetAll}
                            responsive={responsive}
                            arrows={false}
                            draggable={true}
                            scrollable={true}
                        >
                            {tiles.map((tile, i) => {
                                return <span key={`tile-${i}`}>{tile.control}</span>;
                            })}
                        </Carousel>
                    </div>
                </div>
            )}
            <WhatsHappeningModal />
        </>
    );
};

export default withRouter(Focus);
